import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f17119f8"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = { class: "insights-container" };
const _hoisted_3 = { class: "insights-container__description" };
import { ref } from 'vue';
import { useInsightsModalContext } from '../composables';
import InsightsCardsContainer from './InsightsCardsContainer.vue';
var InsightsTabs;
(function (InsightsTabs) {
    InsightsTabs["campaigns"] = "campaigns";
})(InsightsTabs || (InsightsTabs = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'InsightsContainerModal',
    setup(__props) {
        const activeTab = ref(InsightsTabs.campaigns);
        const { isDialogVisible, toggleDialogVisibility } = useInsightsModalContext();
        return (_ctx, _cache) => {
            const _component_el_tab_pane = _resolveComponent("el-tab-pane");
            const _component_el_tabs = _resolveComponent("el-tabs");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                id: "insights-dialog",
                modelValue: _unref(isDialogVisible),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(isDialogVisible) ? (isDialogVisible).value = $event : null)),
                width: "1100px",
                "align-center": "",
                onClosed: _unref(toggleDialogVisibility)
            }, {
                header: _withCtx(() => [
                    _createElementVNode("h3", null, [
                        _createElementVNode("img", {
                            src: require(`@/assets/svgs/white-start-icon.svg`)
                        }, null, 8, _hoisted_1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('strategic-insights.container-modal.title')), 1)
                    ])
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_el_tabs, {
                        modelValue: activeTab.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((activeTab).value = $event)),
                        class: "insights-tabs"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_el_tab_pane, {
                                label: _ctx.$t('strategic-insights.modal-tabs.campaigns'),
                                name: "campaigns"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('strategic-insights.container-modal.description')), 1),
                                        _createVNode(InsightsCardsContainer)
                                    ])
                                ]),
                                _: 1
                            }, 8, ["label"])
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ]),
                _: 1
            }, 8, ["modelValue", "onClosed"]));
        };
    }
});
